import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry error tracking
 *
 * Configuration:
 * - Development: Sentry disabled (errors logged to console)
 * - Production: Full error tracking enabled
 * - Test: Sentry disabled
 */
export function initSentry() {
  // Sentry DSN - same for all environments, use environment tag to differentiate
  const SENTRY_DSN = 'https://f5d8233e9d13c55800fd0aec7ae68ec4@o4510333433675776.ingest.de.sentry.io/4510333440688208';

  // Determine environment
  let environment = 'unknown';
  let enabled = false;

  if (__DEV__) {
    environment = 'development';
    enabled = false; // Disable in dev to avoid noise
  } else if (__TEST__) {
    environment = 'test';
    enabled = false; // Disable in test
  } else if (__PROD__) {
    environment = 'production';
    enabled = true; // Enable in production
  } else if (__LOCAL__) {
    environment = 'local';
    enabled = false; // Disable in local dev
  } else if (__LOCAL_LIVE__) {
    environment = 'local-live';
    enabled = false; // Disable in local-live (connects to prod Firebase but still local)
  }

  // Only initialize if enabled
  if (enabled) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: environment,

      // Don't send errors in development
      enabled: enabled,

      // Sample rate for error events (1.0 = 100%)
      sampleRate: 1.0,

      // Release tracking (optional - can add version from package.json later)
      // release: 'shtum-web@' + process.env.npm_package_version,

      // Integrations
      integrations: [
        // Sentry.browserTracingIntegration(), // Performance monitoring - disabled for now
      ],

      // Don't capture console.log as breadcrumbs (too noisy)
      beforeBreadcrumb(breadcrumb) {
        if (breadcrumb.category === 'console') {
          return null;
        }
        return breadcrumb;
      },
    });

    console.log(`[Sentry] Initialized for environment: ${environment}`);
  } else {
    console.log(`[Sentry] Disabled for environment: ${environment}`);
  }
}

/**
 * Manually capture an exception for testing
 * Can be called from browser console: window.testSentryError()
 */
export function testSentryError() {
  const error = new Error('Test error from Sentry integration');
  Sentry.captureException(error);
  console.log('[Sentry] Test error sent:', error.message);
  alert('Test error sent to Sentry! Check your Sentry dashboard.');
}

// Export Sentry for advanced usage
export { Sentry };
